/*
 * Copyright (c) Nexign, JSC, 2019.
 */

/**
 *
 *
 * @author Yakov Gushchin
 * @author Anton Panasenko
 * @author Maxim Fedorov
 * @version 1.1.0
 * @since 1.1.0
 */

import { ReactElement } from 'react';

import {
    IChartAnimateConfiguration,
    IChartColumnWidthConfiguration,
    IChartErrorConfiguration,
    IChartGridConfiguration,
    IChartLegendConfiguration,
    IChartLoadingConfiguration,
    IChartPaddingConfiguration,
    IChartScaleConfiguration,
    IChartTooltipConfiguration,
    TChartDataConfiguration,
    TChartType,
} from '../chartTypes';

export enum EChartImplementationType {
    category = 'category',
    dynamic = 'dynamic',
}

export interface IChartImplementation {
    animate: IChartAnimateConfiguration;
    columnWidth?: IChartColumnWidthConfiguration;
    dataConfiguration: TChartDataConfiguration;
    error: IChartErrorConfiguration;
    grid: IChartGridConfiguration;
    height: number;
    legend: IChartLegendConfiguration;
    loading: IChartLoadingConfiguration;
    padding: IChartPaddingConfiguration;
    render: () => ReactElement<HTMLDivElement>;
    scale: IChartScaleConfiguration;
    tooltip: IChartTooltipConfiguration;
    type: TChartType;
}
